import { ItemModel } from 'models/Item/Item';
import { RawItemData } from 'models/Item/types';
import { Cloneable } from 'models/Utils/Cloneable';
import { ProcessStatus } from 'models/types';

export const DedupStatus = ProcessStatus;

export interface RawDedupCandidate {
  item_id: string;
  similarity: number;
  item: RawItemData;
}

export interface RawDedupItemGroup {
  item_id: string;
  status: string;
  item: RawItemData;
  candidates: RawDedupCandidate[];
}

function normalizeRawItem(raw: RawItemData & { _id?: string }): RawItemData {
  if (raw && !raw.id && raw._id) {
    return { ...raw, id: raw._id } as RawItemData;
  }
  return raw as RawItemData;
}

export class DedupItemCandidateModel extends Cloneable {
  id: string;
  similarity: number;
  item: ItemModel;

  constructor(raw: RawDedupCandidate) {
    super();
    this.id = raw.item_id;
    this.similarity = raw.similarity;
    this.item = new ItemModel(normalizeRawItem(raw.item as RawItemData & { _id?: string }));
  }
}

export class DedupItemModel extends Cloneable {
  id: string;
  status: string;
  item: ItemModel;
  candidates: DedupItemCandidateModel[];

  constructor(raw: RawDedupItemGroup) {
    super();
    this.id = raw.item_id;
    this.status = raw.status || DedupStatus.PENDING;
    this.item = new ItemModel(normalizeRawItem(raw.item as RawItemData & { _id?: string }));
    this.candidates = (raw.candidates || []).map(candidate => new DedupItemCandidateModel(candidate));
  }

  public isPending(): boolean {
    return this.status === DedupStatus.PENDING;
  }

  public isApproved(): boolean {
    return this.status === DedupStatus.APPROVED;
  }

  public isRejected(): boolean {
    return this.status === DedupStatus.REJECTED;
  }
}
